<template>
  <!-- 补卡申请 -->
  <div class="fillUpCardPage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="propertyData.applicantName"
        v-if="mode != 'add'"
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
      <van-field
        v-model="userinfo.realName"
        v-else
        :required="editType"
        readonly
        label="申请人："
        class="ggInput"
      />
    </van-cell-group>
    <!-- <van-cell-group class="baseNone baseSalary">
      <van-field v-model="propertyData.latitude" required readonly label="纬度：" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field v-model="propertyData.longitude" readonly required label="经度：" />
    </van-cell-group>-->
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="propertyData.placeName"
        readonly
        :required="editType"
        type="textarea"
        rows="1"
        autosize
        label="地点名称："
      />
    </van-cell-group>

    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="propertyData.punchTime"
        readonly
        :required="editType"
        :placeholder="editType ? '请选择' : ''"
        @click="TimePicker()"
        :is-link="editType"
        class="ggInput"
        label="补卡时间："
      />
    </van-cell-group>
    <!-- 所属项目 -->
    <van-cell-group class="itemSite baseNone baseSalary beizhu">
      <van-field
        v-model="propertyData.projectName"
        :required="editType"
        type="textarea"
        label="所属项目："
        :placeholder="editType ? '请选择' : ''"
        @click="checkItemPicker"
        :is-link="editType"
        readonly
        rows="1"
        autosize
      />
    </van-cell-group>
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="propertyData.reason"
        rows="1"
        :required="editType"
        autosize
        label="备注"
        type="textarea"
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
      />
    </van-cell-group>
    <!-- 附件 -->
    <!-- 微信的附件 避免和原生交互 -->
    <!-- <wx-file-view
      v-if="is_weixn"
      :filesData="propertyData"
      :editType="editType"
      class="fileview"
    ></wx-file-view> -->
    <!-- 原生附件 -->
    <!-- <file-view
      v-else
      :filesData="propertyData"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view> -->

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="propertyData"></audit-list>
    </div>

    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="propertyData"></flow-staff>
      <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main
        :applicantData="propertyData"
        @changeVerifyType="setVerifyType"
      ></verify-main>
    </van-popup>

    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        @click="checkInput"
        :loading="btnLoading"
        :loading-text="loadingText"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold' && mode != 'verify'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              @click="delApply"
              :loading="btnLoading"
              :loading-text="loadingText"
              class="btn"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              @click="checkInput"
              :loading="btnLoading"
              :loading-text="loadingText"
              class="btn"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          @click="checkInput"
          :loading="btnLoading"
          :loading-text="loadingText"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        @click="delApply"
        :loading="btnLoading"
        :loading-text="loadingText"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPagePicker">审批</van-button>
    </div>
    <!-- 弹出框 -->
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 时间选择器 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { isEdit, dateFormat, dateTimeFormat } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
const projectView = () => import("@/components/businessTripMould/projectView");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
export default {
  name: "fillUpCard",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      mode: "add",
      editType: false, //能否编辑
      propertyData: {
        id: "",
        applicantName: "",
        applicantId: "", //申请人id
        latitude: "", //纬度
        longitude: "", //经度
        placeName: "", //地点名称
        punchTime: "",
        projectId: "", //项目Id
        projectName: "", //项目名称
        reason: "", //原因
        baseAnnexes: [], //f附件
        verifyStatus: "hold",
      },
      minDate: "",
      currentDate: new Date(), //当前时间
      showTimePicker: false,
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      verifyPageType: false, //审批弹框,默认不显示
      sendType: "", //判断是否在抄送列表
      verifyType: "", //判断是否已审核
      showItemPicker: false, //项目弹框

      clientType: getDeviceType(),
      is_weixn: is_wei(), //是否为微信
    };
  },
  components: {
    projectView,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  mounted() {
    if (is_wei()) {
      document.title = "补卡申请";
    }
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentMonth = date.getMonth();
    console.log(currentMonth, "currentMonth");
    this.minDate = new Date(currentYear, currentMonth, 1);

    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面

    window.setUserPoint = this.setUserPoint; //获取位置回调
    this.$nextTick(() => {
      if (this.userinfo && this.userinfo.realName) {
        this.initPage();
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      if (this.mode == "edit" || this.mode == "verify" || this.mode == "view") {
        this.getdetail();
      } else {
        this.setShowLoad(false);
        this.getAppPoint();
      }
    },
    //项目信息
    checkItemPicker() {
      if (!this.editType) {
        return false;
      }
      this.showItemPicker = true;
    },
    setProject(data) {
      //获取所属项目
      if (data != "") {
        this.propertyData.projectId = data.id;
        this.propertyData.projectName = data.name;
      }
      this.showItemPicker = false;
    },
    TimePicker() {
      if (this.editType) {
        this.showTimePicker = true;
      }
    },
    onTimeConfirm(data) {
      //选择时间回调
      this.showTimePicker = false;
      this.propertyData.punchTime = dateTimeFormat(data);
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.propertyData.baseAnnexes = data;
    },
    //获取当前位置信息
    getAppPoint() {
      //获取用户当前的位置
      if (this.clientType == "android") {
        window.android.getInfo(104);
      } else {
        window.webkit.messageHandlers.getUserPoint.postMessage({
          callBack: "setUserPoint", //回调 必传
        });
      }
    },
    setUserPoint(data) {
      if (this.clientType == "android") {
        this.propertyData.longitude = data.lon;
        this.propertyData.latitude = data.lat;
        this.propertyData.placeName = data.placeName;
      } else {
        let dataObj = JSON.parse(data);
        this.propertyData.longitude = dataObj.lon;
        this.propertyData.latitude = dataObj.lat;
        this.propertyData.placeName = dataObj.placeName;
      }
    },
    verifyPagePicker() {
      this.verifyPageType = true;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.userCenter.user.myfillUpCard
            .deleteRecall(this.propertyData.verifyStatus, _this.propertyData.id)
            .then((res) => {
              if (res.code == "1") {
                _this.$toast.loading({
                  duration: 0, // 持续展示 toast
                  forbidClick: true,
                  message: text + "成功",
                });
                const timer = setInterval(() => {
                  clearInterval(timer);
                  _this.$toast.clear();
                  if (_this.clientType == "android") {
                    window.android.getInfo(103);
                  } else {
                    window.webkit.messageHandlers.closePage.postMessage("1");
                  }
                }, 2000);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，稍后重试");
              _this.btnLoading = false;
            });
        });
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    getdetail() {
      let _this = this;
      _this.$api.userCenter.user.myfillUpCard
        .getReplenish(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );

            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
            _this.setShowLoad(false);
          }
        })
        .catch((err) => {
          _this.setShowLoad(false);
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //保存
    checkInput() {
      let _this = this;
      if (this.validate() && !_this.btnLoading) {
        _this.btnLoading = true;
        _this.$api.userCenter.user.myfillUpCard
          .saveFillCard(_this.mode, _this.propertyData)
          .then((res) => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            _this.$toast("网络失败，稍后重试");
            _this.btnLoading = false;
          });
      }
    },
    validate() {
      let _this = this;
      if (
        this.propertyData.projectName == "" ||
        this.propertyData.reason == ""||!this.propertyData.placeName||!this.propertyData.punchTime
      ) {
        _this.$toast("请完善表单信息");
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function (val) {
        if (val && val.realName) {
          this.initPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.fillUpCardPage {
  width: 100%;

  background-color: #f9f9f9;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    border-radius: 12px;
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    button {
      width: 100%;
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
}
</style>